import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from '../../../services/userService/user.service'
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-detailtask',
  templateUrl: './detailtask.component.html',
  styleUrls: ['./detailtask.component.css']
})

export class DetailtaskComponent implements OnInit {
  registerForm: any;
  id: any;
  formdata: any;
  isCollapsed: boolean = false;
  Titlearray: any = [];
  Followerarray: any = [];
  selectedTitleName: any = '';
  selectedfollowerName: any = '';
  history: any = [];
  proname: boolean = true;
  inqnumber: boolean = true;
  permission: any;
  userRId: any;

  constructor(
    private formBuilder: FormBuilder,
    private UserService: UserService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    let decid = this.route.snapshot.params['id'];
    decid = decid.toString().replace('Ar1t', '=').replace('FGH', '/').replace('THD', '+');
    this.id = this.UserService.decryptData(decid);
    let permi = JSON.parse(localStorage.getItem('Permission'));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem('roleId');
    this.userRId = this.UserService.decryptData(userrId);
    if (this.permission.Task_View != 1 && this.userRId != 1) {
      this.toastr.error('You do not have permission');
      this.router.navigate(['/profile']);
    }

    this.registerForm = this.formBuilder.group({
      Task_id: [''],
      ProjectName: [''],
      InquiryName: [''],
      TaskTitleName: [''],
      TaskStatus: [''],
      StartDate: [''],
      EndDate: [''],
      AssignedTo: [''],
      TaskFollowers: [''],
      TaskPriority: [''],
      TaskDescription: [''],
      Remark: [''],
      ActionTaken: [''],
      OutcomeRemark: [''],
    })
    let data = {
      "TaskId": this.id
    }
    this.spinner.show();
    this.UserService.GetTaskDetailById(data).subscribe(res => {
      if (res['result'] == 'success') {
        this.spinner.hide();
        this.formdata = res['Data'];
        this.Titlearray = res['TaskTitle'];
        this.Titlearray.forEach(element => {
          this.selectedTitleName += element['TaskTitleName'] + ', ';
        });
        this.formdata.TaskTitleName = this.selectedTitleName.slice(0, -2);
        this.Followerarray = res['TaskFollower'];
        this.Followerarray.forEach(element => {
          this.selectedfollowerName += element['UserName'] + ', ';
        });
        this.formdata.UserName = this.selectedfollowerName.slice(0, -2);
      }
    })
    let data1 = {
      "TaskId": this.id
    }
    this.UserService.TaskActivityHistory(data1).subscribe(res => {
      if (res['result'] == 'success') {
        this.history = res['Data'];
        this.Titlearray = res['TaskTitle'];
        this.Titlearray?.forEach(element => {
          this.selectedTitleName += element['TaskTitleName'] + ', ';
        });
        this.history.TaskTitleName = this.selectedTitleName;
        this.registerForm.patchValue({
        })
      }
    })
    this.isCollapsed = false;
  }

  openClosefun() {
    this.isCollapsed = !this.isCollapsed
  }

}
